import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { useRoute, useRouter } from 'vue-router'
import { ref, watch, reactive,onMounted,computed} from 'vue';
import Cookies from "js-cookie";
import store from '@/store/index'



export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const route = useRoute()
const router = useRouter()
watch(
  () => route.fullPath,
  (n, o) => {
    if(n.substring(0,6)==='/admin'){
      if(Cookies.get("cookie")!=undefined){
      }else{
        router.push("/login");
      }
    }else if(n.substring(0,6)==='/login'){
      if(Cookies.get("cookie")!=undefined){
        router.push("/admin");
      }
    }
      
  }
)

router.beforeEach((to, from, next) => {
    store.commit('changeView', to.fullPath)
    
    next();
});

onMounted(()=>{
  
})

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createBlock(_component_router_view))
}
}

})